import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { PaginationClientSideComponent } from "../app/_component/pagination-client-side/pagination-client-side.component";
import { PaginationColumn } from "../app/_component/pagination-client-side/pagination-column.class";

@Injectable()
export class RowsLoaderService {
  constructor(public transServ: TranslateService) {}

  public paginationComponent: PaginationClientSideComponent;
  private rows: any[] = [];
  public rowsVisible: any[] = [];
  public rowsVisibleInitCount = 24;
  public rowsAddCount = 12;
  public allRowsVisible = false;
  public bookingDate = new Date();
  private sortColumn: string = '';

  customDataSubject: Subject<any> = new Subject<any>();

  public init(rows: any[], sorted: boolean = false) {
    this.rows = rows;
    if(!sorted) {
      this.paginationComponent.currentSortDisplay = '';
    }
    if (rows.length > this.rowsVisibleInitCount) {
      this.rowsVisible = rows.slice(0, this.rowsVisibleInitCount);
      this.allRowsVisible = false;
    } else {
      this.rowsVisible = rows;
      this.allRowsVisible = true;
    }

    if (this.paginationComponent) {
      this.paginationComponent.refreshComponentsReferences();

      if (this.paginationComponent.infiniteScroll) {
        this.paginationComponent.infiniteScroll.disabled = false;
      }
    }
  }

  public showMoreRows(): boolean {
    let from = this.rowsVisible.length;
    let to = from + this.rowsAddCount;
    let len = this.rows.length;

    if (to >= len) {
      to = len;
      this.allRowsVisible = true;
    }

    for (let i = from; i < to; i++) {
      let row = this.rows[i];
      this.rowsVisible.push(row);
      this.paginationComponent.addDynamicComponentAuto(i);
    }

    return !this.allRowsVisible;
  }

  public clear() {
    this.rows = this.rowsVisible = [];
    this.paginationComponent = null;
  }

  public sort(column: string, dir: string) {
    this.sortColumn = column;
    if (!this.rows || this.rows.length == 0) {
      return;
    }

    let asc = dir == this.transServ.instant("SORT_ASC") ? 1 : -1;

    let sortFn = null;
    let columnDef: PaginationColumn;

    if (this.paginationComponent) {
      columnDef = this.paginationComponent.columns.find(
        (c) => c.name == column
      );
    }
    sortFn = (a, b) => {
      let aVal, bVal;

      if (columnDef.colValue) {
        aVal = columnDef.colValue(a);
        bVal = columnDef.colValue(b);
      } else {
        aVal = a[column];
        bVal = b[column];
      }

      // Filtrowanie po dacie, wymaga przesłania poprawnej daty
      if(aVal instanceof Date && bVal instanceof Date)
        return asc === 1 ? aVal.getTime() - bVal.getTime() : bVal.getTime() - aVal.getTime(); 

      let aArray = this.createArrayFromCellValue(aVal),
      bArray = this.createArrayFromCellValue(bVal);

      for (var i in aArray) {
        // Check if strings or numbers are equal. If yes, don't compare.
        if (aArray[i] !== bArray[i] && aArray[i] - bArray[i] !== 0) {
          if (this.isNumber(aArray[i]) && this.isNumber(bArray[i])) {
            if (asc === 1) {
              return aArray[i] - bArray[i];
            } else {
              return bArray[i] - aArray[i];
            }
          }else {
            if (asc === 1) {
              return aArray[i].localeCompare(
                bArray[i] ? bArray[i] : 0,
                "en-US-u-kf-upper"
              );
            } else {
              return bArray[i]
                ? bArray[i].localeCompare(aArray[i], "en-US-u-kf-upper")
                : -1;
            }
          }
        }
      }
      return 0;
    };


    this.rows.sort(sortFn);
    this.init(this.rows, true);
  }

  createArrayFromCellValue(value) {
    value += "";

    if (value == "null") {
      value = "";
    }

    return value
      .trim()
      .split(/([0-9,.]+)/)
      .filter((elem) => elem != "");
  }

  isNumber(string) {
    const num = Number(string);
    return num || num === 0;
  }

  public getRowsCount() {
    return this.rows ? this.rows.length : 0;
  }

  /**
   * Sprawdza czy mozna grupować dane w trakcie sortowania po aktulanej kolumnie. 
   * 
   * @param columnNames Tablica nazw kolumn, przy których grupowanie jest bezproblemowe
   * @returns Czy kolumna po której aktualnie się sortuje, jest bezproblemowa w grupowaniu
   */
  isNoProblemSortingColumn(columnNames: string[]=[]): boolean {
    if(!columnNames.length || !this.sortColumn.length){
      return true; // Jeżeli nie wyróżniono konkretnych kolumn to znaczy, że przy wszystkich kolumnach grupowanie działa dobrze
    }
    
    for(let i=0; i<columnNames.length; i++)
      if(this.sortColumn === columnNames[i])
        return true;
    
    return false;
  }
}
